import React, { useContext, useEffect, useState } from "react";
import { useMutation } from "react-query";
import Notiflix from "notiflix";
import { useHistory } from "react-router-dom";

import Modal from "components/common/Modal";

import { payMadaBillApiCalled } from "shared/endPoints/apiCallers";
import {
  Box,
  Button,
  IconButton,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { noBalanceContext } from "reducers/no_balance";
import translate from "i18n/translate";
import SaveIcon from "@mui/icons-material/Save";
import EditIcon from "@mui/icons-material/Edit";
import CancelIcon from "@mui/icons-material/Cancel";

const PayBillsMadaModal = ({
  number,
  billSelected,
  isDisabled,
  clearSelections,
}) => {
  const noBalanceCtx = useContext(noBalanceContext);

  const [isOpen, setIsOpen] = useState(false);
  const [countryCode, setCountryCode] = useState("970");
  const [wNumber, setWNumber] = useState(null);
  const [email, setEmail] = useState(null);
  const [changeText, setChangeText] = useState(billSelected?.amount);
  const [selectedBill, setSelectedBill] = useState(billSelected);
  const [isEditable, setIsEditable] = useState(false);
  const history = useHistory();
  useEffect(() => {
    setSelectedBill(billSelected);
    setChangeText(billSelected?.amount);
  }, [billSelected]);
  const handleCountryCodeChange = (event) => {
    setCountryCode(event.target.value);
  };

  const { mutateAsync: payMadaBill, isLoading } = useMutation(
    payMadaBillApiCalled,
    {
      onSuccess: (res) => {
        if (res?.reason === "seller no balamce/ disabled") {
          return "noBalance";
        }
        if (res?.status === "failed") {
          Notiflix.Notify.failure(res?.reason || "Something went wrong");
          return;
        }
        setIsOpen(false);
        setWNumber(null);
        setEmail(null);
        clearSelections();
        history.push("/pay_bills");
      },
      onError: () => {
        Notiflix.Notify.failure(`Something went wrong !`, "", "Close");
      },
    }
  );

  const onSubmit = async (e) => {
    e.preventDefault();
    const whatsappNumber = `${countryCode}${wNumber}`;
    
    // Extract required fields from selectedBill
    const serviceNumber = selectedBill?.originalBill?.raw_bill_data?.user_bill?.serviceIdentifier?.value || 
                         selectedBill?.originalBill?.raw_bill_data?.userBill?.serviceIdentifier?.value ||
                         number; // fallback to number if service_number not found
    
    const invoiceNumber = selectedBill?.originalBill?.invoice_number || 
                         selectedBill?.originalBill?.biller_reference_id ||
                         selectedBill?.ref; // fallback to ref if invoice_number not found
    
    const amount = selectedBill?.amount?.split(" ")?.[0] || 
                  selectedBill?.originalBill?.amount;
    
    const billingPeriod = selectedBill?.originalBill?.cycle || 
                         selectedBill?.cycle ||
                         selectedBill?.originalBill?.raw_bill_data?.yearMonth ||
                         "N/A";
    
    const payload = {
      service_number: serviceNumber,
      invoice_number: invoiceNumber,
      amount: amount,
      billing_period: billingPeriod,
      wNumber: wNumber ? whatsappNumber : "N/A",
      email: email ?? "N/A",
    };
    console.log("PayBillsMadaModal -> payload", payload);
    const status = await payMadaBill(payload);
    if (status?.reason === "seller no balamce/ disabled") {
      noBalanceCtx.openCardHandler();
    }
    history.push("/pay_bills");
    setIsOpen(false);
  };

  const handleChange = (e) => {
    setChangeText(e.target.value);
  };
  const handleSaveClick = () => {
    setIsEditable(false);
    if (changeText === selectedBill?.amount || changeText?.trim()?.length === 0)
      setChangeText(selectedBill?.amount);
    else setSelectedBill({ ...selectedBill, amount: changeText });
  };

  const handleCancelClick = () => {
    setIsEditable(false);
    setChangeText(selectedBill?.amount);
  };

  return (
    <div id="mada-pay-bills-modal-div">
      <Button
        onClick={() => {
          !isDisabled && setIsOpen(true);
        }}
        id="mada-pay-bills-pay-btn"
        disabled={isDisabled}
      >
        {translate("Bills")}
      </Button>
      {isOpen && (
        <Modal
          visible={isOpen}
          onClose={() => setIsOpen(false)}
          title={"Pay"}
          width={"40vw"}
          id="mada-pay-bills-modal"
          onSuccess={onSubmit}
          onSuccessLoading={isLoading}
          onSuccessDisable={isEditable}
        >
          <form className="phone-form" id="mada-bills-modal-form">
            <div className="d-flex w-100 justify-content-around mb-4">
              <div className="bg-light p-3 rounded">
                <h6 className="m-0">
                  {translate("Number")}: {number}
                </h6>
              </div>
              {!isEditable ? (
                <div
                  className="bg-light p-3 rounded d-flex  "
                  style={{
                    alignItems: "center",
                  }}
                >
                  <h6 className="m-0">
                    {translate("money")}: {selectedBill?.amount} ILS
                  </h6>
                  <IconButton onClick={() => setIsEditable(true)} size="small">
                    <EditIcon color="success" /> {translate("Edit")}
                  </IconButton>
                </div>
              ) : (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <span> {translate("money")}: </span>
                  <TextField
                    value={changeText}
                    onChange={handleChange}
                    //   onBlur={handleSaveClick}
                    // className={classes.textField}
                    variant="outlined"
                    size="small"
                    style={{ width: 100 }}
                  />
                  <IconButton onClick={handleSaveClick} size="small">
                    <SaveIcon sx={{ ml: "2px", mr: "2px" }} color="info" />
                  </IconButton>
                  <IconButton onClick={handleCancelClick} size="small">
                    <CancelIcon sx={{ ml: "2px", mr: "2px" }} color="error" />
                  </IconButton>
                </Box>
              )}
            </div>
            <Box sx={{ display: "flex", width: "80%" }}>
              <Select
                value={countryCode}
                onChange={handleCountryCodeChange}
                sx={{ width: "25%" }}
              >
                <MenuItem value="972">+972 </MenuItem>
                <MenuItem value="970">+970 </MenuItem>
                {/* Add more country codes and names as needed */}
              </Select>
              <TextField
                value={wNumber}
                type="number"
                onChange={(e) => setWNumber(e.target.value)}
                // placeholder="Whatsapp number"
                label={translate("Whatsapp number")}
                id="phone-number-input-field"
                sx={{ width: "75%" }}
              />
            </Box>
            <Box sx={{ width: "80%", mt: "16px" }}>
              <TextField
                value={email}
                type="email"
                id="mada-pay-bills-email-input-field"
                onChange={(e) => setEmail(e.target.value)}
                // placeholder="Email"
                label="Email"
                sx={{ width: "100%" }}
              />
            </Box>
          </form>
        </Modal>
      )}
    </div>
  );
};

export default PayBillsMadaModal;
